import clsx from 'clsx';
import StatusIcon from 'core/modules/atoms/StatusIcon/StatusIcon';
import PropTypes from 'prop-types';
import React from 'react';
import useInputPoints from './useInputPoints';

const InputPoints = ({
  onChange,
  placeholder = '0',
  type = 'text',
  disabled = false,
  referer,
  size = 'default',
  pointsTotal = 10,
  isScoreReadOnly,
  max,
  min,
  showDotted = false,
  isLate = false,
  colorsPoints,
  ...props
}) => {
  const { value, hasError, onChangeText, onFocus, onBlur, statusColor, t } = useInputPoints({ props, max, onChange, colorsPoints, pointsTotal });

  return (
    <div className={clsx('input-points', `input-points--status-${statusColor}`, { 'input-points--read-only': isScoreReadOnly }, `input-points--size-${size}`)}>
      <div className={clsx('input-points__input-container', { 'has-error': hasError }, { 'input-points__input-container--dotted': showDotted })}>
        <input
          className={clsx('input-points__input', { 'input-points__input--disabled': disabled })}
          type={type}
          placeholder={placeholder}
          onChange={onChangeText}
          onFocus={onFocus}
          onBlur={onBlur}
          disabled={disabled}
          ref={referer}
          readOnly={isScoreReadOnly}
          max={max}
          min={min}
          value={value}
        />
        {isLate && (
          <div className="input-points__late">
            <StatusIcon iconName="exclamation-circle" label={t('lesson:Delivered late')} shouldShowTooltip />
          </div>
        )}
        <label className="input-points__points-total">/{pointsTotal}</label>
      </div>
    </div>
  );
};

InputPoints.propTypes = {
  colorsPoints: PropTypes.bool,
  disabled: PropTypes.bool,
  isLate: PropTypes.bool,
  isScoreReadOnly: PropTypes.bool,
  max: PropTypes.number,
  min: PropTypes.number,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  pointsTotal: PropTypes.number,
  referer: PropTypes.object,
  showDotted: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'big', 'medium']),
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default InputPoints;
